import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './pageHeader';
import Footer from './pageFooter';
import WorkshopHome from './WorkshopHome';
import RfpPortal from './RfpPortal';
import MaintenanceCalculator from './MaintenanceCalculator';
import OrdersDashboard from './OrdersDashboard';
import ProjectTracker from './ProjectTracker';
import AdminProposalStudio from './AdminProposalStudio';
import ClientDashboard from './ClientDashboard';
import AuthModal from './AuthModal';
import TapeLanding from './TapeLanding';
import TapeLegal from './TapeLegal';
import './App.css';

const App = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalTab, setAuthModalTab] = useState('login');

  const handleOpenAuth = (tab = 'login') => {
    setAuthModalTab(tab);
    setIsAuthModalOpen(true);
  };

  useEffect(() => {
    const handleAuthEvent = (e) => {
      handleOpenAuth(e.detail || 'login');
    };
    window.addEventListener('open_auth_modal', handleAuthEvent);
    return () => window.removeEventListener('open_auth_modal', handleAuthEvent);
  }, []);

  return (
    <div className="app-container" style={{ minHeight: '100vh', position: 'relative' }}>
      {/* Living AI Generative Dotted Background */}
      <div className="global-ai-background" aria-hidden="true">
        <div className="ai-dot-grid-base" />
        <div className="ai-ambient-aura-1" />
        <div className="ai-ambient-aura-2" />
        <div className="ai-dot-grid-glowing">
          <div className="ai-dot-light-sweep-1" />
          <div className="ai-dot-light-sweep-2" />
          <div className="ai-dot-light-sweep-3" />
        </div>
      </div>

      {/* Software Navigation Bar */}
      <Header onOpenAuth={handleOpenAuth} />
      
      <main style={{ position: 'relative', zIndex: 1 }}>
        <Switch>
          {/* Root route: Software Platform */}
          <Route exact path="/">
            <WorkshopHome onOpenAuth={handleOpenAuth} />
          </Route>
          
          {/* Client Account Dashboard */}
          <Route path="/dashboard">
            <ClientDashboard onOpenAuth={handleOpenAuth} />
          </Route>

          {/* Universal Project Tracking & SOW Lifecycle */}
          <Route path="/project/:id" component={ProjectTracker} />
          <Route path="/project" component={ProjectTracker} />
          <Route path="/track" component={ProjectTracker} />

          {/* Engineering Review & Proposal Workbench */}
          <Route path="/admin" component={AdminProposalStudio} />
          <Route path="/proposal-studio" component={AdminProposalStudio} />
          
          {/* Specialized Portals & Ledgers */}
          <Route path="/rfp" component={RfpPortal} />
          <Route path="/calculator" component={MaintenanceCalculator} />
          <Route path="/orders" component={OrdersDashboard} />
          
          {/* Digital Product & Legal Routes */}
          <Route path="/tape" component={TapeLanding} />
          <Route path="/tape-privacy">
            <TapeLegal type="privacy" />
          </Route>
          <Route path="/tape-terms">
            <TapeLegal type="terms" />
          </Route>
          <Route path="/tape-support">
            <TapeLegal type="support" />
          </Route>
          
          {/* Fallback to WorkshopHome */}
          <Route>
            <WorkshopHome onOpenAuth={handleOpenAuth} />
          </Route>
        </Switch>
      </main>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        initialTab={authModalTab}
      />

      {/* Software Enterprise Footer */}
      <Footer />
    </div>
  );
};

export default App;